import { Instagram, WhatsApp, Strava } from './utils/variables.js';

export const routes = [
    // Views
    { path: '/404', loader: () => import('./views/Error404.js'), title: 'Agora Haus | 404', props: { default: true } }, // Default View
    { path: '/', loader: () => import('./views/Home.js'), title: 'Agora Haus' },

    // Redirects (External)
    { path: '/instagram', loader: () => import('./views/RedirectExternal.js'), props: { to: Instagram } },
    { path: '/chat', loader: () => import('./views/RedirectExternal.js'), props: { to: WhatsApp } },
    { path: '/strava', loader: () => import('./views/RedirectExternal.js'), props: { to: Strava } },
];